/**
 * Internal dependencies
 */
import metadata from './block.json';
import edit from './edit';
import save from './save';
import variations from './variations';
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';

import './actions/email';
import './actions/subscribe';

const { name } = metadata;

registerBlockType( name, {
	/**
	 * @see ./edit.js
	 */
	edit,

	/**
	 * @see ./save.js
	 */
	save,

	variations,
} );
